const searchSuggestion = [
  {
    integration: 'Salesforce',
    link: '/integrations/salesforce',
    logo: 'logo--salesforce',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Seamlessly transfer call <br> information and qualified leads directly to your CRM.',
  },
  {
    integration: 'Microsoft Teams',
    link: '/integrations/microsoft-teams',
    logo: 'logo--microsoft-teams',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Get the latest call messages directly in your chosen channels.',
  },
  {
    integration: 'Zoho',
    link: '/integrations/zoho',
    logo: 'logo--zoho',
    logoWidth: 30,
    logoHeight: 30,
    description:
      'Automatically upload call data <br> into your Zoho CRM fields and cut out the middleman.',
  },
  {
    integration: 'Slack',
    link: '/integrations/slack',
    logo: 'logo--slack',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Capture leads and share call info <br> in a click through your Slack <br> channels.',
  },
  {
    integration: 'ServiceMinder',
    link: '/integrations/serviceminder',
    logo: 'logo--service-minder',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Simplify deal management by syncing call details to your CRM.',
  },
  {
    integration: 'Zapier',
    link: '/integrations/zapier',
    logo: 'logo--zapier-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Integrate your AnswerConnect service with Zapier and connect with hundreds of apps.',
  },
  {
    integration: 'Zendesk',
    link: '/integrations/zendesk',
    logo: 'logo--zendesk',
    logoWidth: 40,
    logoHeight: 40,
    description: 'Respond to caller inquiries <br> through one centralized channel.',
  },
  {
    integration: 'Freshdesk',
    link: '/integrations/freshdesk',
    logo: 'logo--freshdesk',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Supercharge your sales process <br> by delivering a faster pipeline and a reduced workload.',
  },
  {
    integration: 'Hubspot',
    link: '/integrations/hubspot',
    logo: 'logo--hubspot',
    logoWidth: 30,
    logoHeight: 32,
    description:
      'Manage calls and categorise <br> leads directly in your dashboard.',
  },
  {
    integration: 'Pipedrive',
    link: '/integrations/pipedrive',
    logo: 'logo--pipedrive-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Unlock more time, deliver a faster sales pipeline and reduce workloads.',
  },
  {
    integration: 'ConnectWise',
    link: '/integrations/connectwise',
    logo: 'logo--connectwise',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Run your entire operation from one place.',
  },
  {
    integration: 'Google Sheets',
    link: '/integrations/googlesheets',
    logo: 'logo--google-sheets',
    logoWidth: 30,
    logoHeight: 32,
    description: 'Add call data into your spreadsheets in real-time.',
  },
  {
    integration: 'Copper',
    link: '/integrations/copper',
    logo: 'logo--copper',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Give your customers personalized messages and build valuable relationships.',
  },
  {
    integration: 'Google Contacts',
    link: '/integrations/googlecontacts',
    logo: 'logo--google-contacts',
    logoWidth: 40,
    logoHeight: 40,
    description: 'Manage your contacts through one simple system.',
  },
  {
    integration: 'Thryv',
    link: '/integrations/thryv',
    logo: 'logo--thryv',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Manage, message and market to your customers, all from one place.',
  },
  {
    integration: 'Klaviyo',
    link: '/integrations/klaviyo',
    logo: 'logo--klaviyo',
    logoWidth: 40,
    logoHeight: 40,
    description: 'Keep your email lists clean, current and correct.',
  },
  {
    integration: 'Capsule',
    link: '/integrations/capsule',
    logo: 'logo--capsule',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description: 'Keep your pipeline moving and land every deal.',
  },
  {
    integration: 'Podio',
    link: '/integrations/podio',
    logo: 'logo--podio',
    logoWidth: 40,
    logoHeight: 40,
    description: 'Make quick, focused progress with every project.',
  },
  {
    integration: 'Active Campaign',
    link: '/integrations/activecampaign',
    logo: 'logo--active-campaign',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Get more sales when your customer call data goes straight to your CRM platform.',
  },
  {
    integration: 'Monday',
    link: '/integrations/monday',
    logo: 'logo--monday',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Keep your projects moving and your data clean around the clock.',
  },
  {
    integration: 'Podium',
    link: '/integrations/podium',
    logo: 'logo--podium',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Make every conversation convenient for customers and successful for your business.',
  },
  {
    integration: 'Constant Contact',
    link: '/integrations/constantcontact',
    logo: 'logo--constant-contact-new',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Turn callers into contacts and reach them with personalised emails, surveys and more.',
  },
  {
    integration: 'Workiz',
    link: '/integrations/workiz',
    logo: 'logo--workiz',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Automate admin and manage all aspects of your field service business in one place.',
  },
  {
    integration: 'Chime',
    link: '/integrations/chime',
    logo: 'logo--chime',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Automate admin and manage all aspects of your field service business in one place.',
  },
  {
    integration: 'Setmore',
    link: '/integrations/setmore',
    logo: 'logo--setmore',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Manage, message and market to your customers, all from one place.',
  },
  {
    integration: 'Less Annoying CRM',
    link: '/integrations/less-annoying-crm',
    logo: 'logo--less-annoying-crm',
    logoWidth: 40,
    logoHeight: 40,
    description: 'Export details from call intake straight to your CRM.',
  },
  {
    integration: 'Keap',
    link: '/integrations/keap',
    logo: 'logo--keap',
    logoWidth: 40,
    logoHeight: 40,
    description:
      "Send call details to your CRM and optimize your brand's outreach.",
  },
  {
    integration: 'Clio',
    link: '/integrations/clio',
    logo: 'logo--clio',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Automatically attach details from calls and chats to your Clio contacts.',
  },
  {
    integration: 'Clio Grow',
    link: '/integrations/clio-grow',
    logo: 'logo--clio-grow',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Eliminate manual data entry by auto-exporting details from call intake.',
  },
  {
    integration: 'PSA',
    link: '/integrations/PSA',
    logo: 'logo--psa',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Automatically create a new job in your PSA account from call intake.',
  },
  {
    integration: 'Lofty',
    link: '/integrations/lofty',
    logo: 'logo--lofty',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Log messages automatically to keep your tasks fresh and visible.',
  },
  {
    integration: 'Outlook',
    link: '/integrations/microsoft-outlook',
    logo: 'logo--microsoft-outlook',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Select a time range and export call intake details to your Outlook inbox.',
  },
  {
    integration: 'Twilio',
    link: '/integrations/twilio',
    logo: 'logo--twilio',
    logoWidth: 40,
    logoHeight: 40,
    viaZapier: true,
    description:
      'Trigger automated SMS or workflows in Twilio from new calls and messages.',
  },
  {
    integration: 'MailerLite',
    link: '/integrations/mailerlite',
    logo: 'logo--mailerlite',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Nurture leads by adding new caller details to a targeted email campaign.',
  },
  {
    integration: 'Mailchimp',
    link: '/integrations/mailchimp',
    logo: 'logo--mailchimp',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Send targeted email campaigns to your new leads from calls and chats.',
  },
  {
    integration: 'Trello',
    link: '/integrations/trello',
    logo: 'logo--trello',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Keep your team up to speed by sharing new call details to a Trello board.',
  },
  {
    integration: 'PracticePanther',
    link: '/integrations/practice-panther',
    logo: 'logo--practicepanther',
    logoWidth: 40,
    logoHeight: 40,
    description:
      'Push details from calls and chats to PracticePanther in real-time.',
  },
];

export default searchSuggestion;
